import React from 'react'

import { Drawer, useDisclosure } from '@chakra-ui/react'
import { useBlockTransition } from 'src/hooks/useBlockTransition'

import { EditIcfDocumentRenewal } from './edit-renewal'
import { useEditIcfDocument } from './edit.hooks'
import { RevisionHistoryContainer } from '../revision-history/revision-history-container'

export const EditIcfDocumentContainer: React.FC = () => {
  const {
    icfDocument,
    latestRevision,
    errors,
    listPath,
    shouldSelectHospital,
    hospitalName,
    latestFilePreviewUrl,
    canUpdate,
    canChangeDocumentType,
    canSetDocuSignRole,
    hasSetDocuSignRole,
    approvalHandlers,
    pullDownState,
    deleteModalState,
    disableModalState,
    enableModalState,
    latestRevisionStatus,
    hasMultipleRevisionHistories,
    hasTempFile,
    onRedirectDocuSignEdit,
    onRedirectDocuSignAgreementFormPreview,
    onChangeName,
    onChangeVersion,
    onChangeDocumentType,
    onChangeRequiredPatientSign,
    onSelectFile,
    onValidate,
    onSubmitUpdate,
    onSubmitDelete,
    onDisable,
    onEnable,
    onCancelRevision,
    navigateToAddRevision,
  } = useEditIcfDocument()

  useBlockTransition({
    showAlert: canUpdate,
  })

  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} size="xl">
        <RevisionHistoryContainer />
      </Drawer>

      <EditIcfDocumentRenewal
        icfDocument={icfDocument}
        latestRevision={latestRevision}
        errors={errors}
        listPath={listPath}
        shouldSelectHospital={shouldSelectHospital}
        hospitalName={hospitalName}
        latestFilePreviewUrl={latestFilePreviewUrl}
        canChangeDocumentType={canChangeDocumentType}
        canUpdate={canUpdate}
        canEdit={latestRevisionStatus.canEdit}
        canPublish={latestRevisionStatus.canPublish}
        canDisable={latestRevisionStatus.canDisable}
        canAddRevision={latestRevisionStatus.canAddRevision}
        canSetDocuSignRole={canSetDocuSignRole}
        hasSetDocuSignRole={hasSetDocuSignRole}
        pullDownState={pullDownState}
        deleteModalState={deleteModalState}
        requestApprovalModalState={approvalHandlers.requestApprovalModalState}
        withdrawModalState={approvalHandlers.withdrawModalState}
        publishModalState={approvalHandlers.publishModalState}
        approveModalState={approvalHandlers.approveModalState}
        rejectModalState={approvalHandlers.rejectModalState}
        disableModalState={disableModalState}
        enableModalState={enableModalState}
        hasMultipleRevisionHistories={hasMultipleRevisionHistories}
        hasTempFile={hasTempFile}
        onRedirectDocuSignEdit={onRedirectDocuSignEdit}
        onRedirectDocuSignPreview={onRedirectDocuSignAgreementFormPreview}
        onChangeName={onChangeName}
        onChangeVersion={onChangeVersion}
        onChangeDocumentType={onChangeDocumentType}
        onChangeRequiredPatientSign={onChangeRequiredPatientSign}
        onSelectFile={onSelectFile}
        onValidate={onValidate}
        onSubmitUpdate={onSubmitUpdate}
        onSubmitDelete={onSubmitDelete}
        onPublish={approvalHandlers.onPublish}
        onRequestApproval={approvalHandlers.onRequestApproval}
        onWithdraw={approvalHandlers.onWithdrawApprovalRequest}
        onApprove={approvalHandlers.onApprove}
        onReject={approvalHandlers.onReject}
        onDisable={onDisable}
        onEnable={onEnable}
        onCancelRevision={onCancelRevision}
        navigateToAddRevision={navigateToAddRevision}
        openRevisionHistoryPane={onOpen}
      />
    </>
  )
}
